import { render, staticRenderFns } from "./ArticlesListView.vue?vue&type=template&id=fa8b6a7e&scoped=true&"
import script from "./ArticlesListView.vue?vue&type=script&lang=js&"
export * from "./ArticlesListView.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesListView.vue?vue&type=style&index=0&id=fa8b6a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8b6a7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAlert,VContainer,VSheet})
